(() => {
  if (window.MarameFormFeedback) return;
  const handled = new WeakSet();
  const reveal = root => {
    const statuses = [...root.querySelectorAll('[data-marame-form-status]')].filter(node => !handled.has(node));
    if (!statuses.length) return;
    statuses.forEach(node => handled.add(node));
    let formId = '';
    try { formId = decodeURIComponent(window.location.hash.slice(1)); } catch {}
    const status = statuses.find(node => node.closest('form')?.id === formId)
      || statuses.find(node => node.dataset.marameFormStatus === 'error') || statuses[0];
    requestAnimationFrame(() => requestAnimationFrame(() => {
      if (!status.isConnected) return;
      status.focus({ preventScroll: true });
      status.scrollIntoView({ behavior: 'instant', block: 'center' });
    }));
  };
  window.MarameFormFeedback = { reveal };
  reveal(document);
  document.addEventListener('shopify:section:load', event => reveal(event.target));
})();
